import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { CreateParticipantUserLabel } from '../mutations/createParticipantUserLabel.mutation';
import type {
  CreateParticipantUserLabelMutation,
  CreateParticipantUserLabelMutationVariables,
} from '../types';

export const useCreateParticipantUserLabelMutation = (
  options?: MutationOptions<
    CreateParticipantUserLabelMutation,
    CreateParticipantUserLabelMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CreateParticipantUserLabel), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
